/**
 * FloatingDialog
 * 
 * @Author: Focci
 * @Date: 2024-01-17 10:14:32
 * @Last Modified by: Focci
 * @Last Modified time: 2024-01-17 10:14:32
 */

'use client'

import PropTypes from 'prop-types'
import { Dialog, DialogContent } from '@comp/material'

export default function FloatingDialog({
  width = '43rem', // 宽度
  DialogContentProps,
  DialogProps,
  children
}) {
  return (
    <Dialog
      scroll="body"
      sx={{ '& .MuiPaper-root': { maxWidth: '90%' } }}
      {...DialogProps}
    >
      <DialogContent
        className="max-w-full mx-auto p-0"
        style={{ width }} 
        {...DialogContentProps}
      >
        {children}
      </DialogContent>
    </Dialog>
  )
}

FloatingDialog.propTypes = {
  width: PropTypes.string,
  DialogContentProps: PropTypes.object,
  DialogProps: PropTypes.object,
}
